import { render } from "./CurrentTimePeriod.vue?vue&type=template&id=4f25e936"
import script from "./CurrentTimePeriod.vue?vue&type=script&lang=js"
export * from "./CurrentTimePeriod.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__